<template>
<div class="parentx-static">
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="updateReminConfig.isOpen"
    id="update-reminder"
  >
    <div class="flex align-center justify-between px-6">
      <h4 class="text-2xl font-bold">Edit Reminder Campaign Info</h4>
      <feather-icon icon="XIcon" @click.stop="closeUpdateRemin" class="cursor-pointer pt-4"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
   <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
     <div class="sidebar-content scroll">
      <div class="info-form"
      data-aos="fade-up"
      data-aos-offset="200"
      data-aos-delay="10"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
      data-aos-anchor-placement="top-center"
      >
        <div class="update-content p-6" style="position: relative">
              <h4 class="text-lg font-bold">What is your offer name?</h4>
              <div class="centerx labelx">
                <vs-input disabled :maxlength="50" v-validate="'required'" name="reminder_name" v-model="reminder_name" :danger="errors.has('reminder_name')"
              danger-text="The reminder name field is required" class="w-full reminder-name"/>
              </div>
              <h4 class="text-lg font-bold">What is the value of promotion?</h4>
              <div class="w-row">
                <ul class="centerx flex align-center justify-between">
                  <vs-input-number min="0" :max="max" v-model="reminder_logic_value" :key="abc" inline controls class="w-7/12"/>
                  <li @click="max=100,abc++">
                    <vs-radio v-model="reminder_logic_type" vs-value="percent" class="flex align-center m-0">%</vs-radio>
                  </li>
                  <li @click="max=999,abc++" class="mr-base">
                    <vs-radio v-model="reminder_logic_type" vs-value="usd" class="flex align-center m-0">$</vs-radio>
                  </li>
                </ul>
              </div>
              <h4 class="text-lg font-bold">How long do you want to maintain this reminder?</h4>

              <v-select v-validate="'required'" name="reminder_expired_day_in" v-model="reminder_expired_day_in" label="text" :options="offer_choices" class="w-7/12" :clearable="false" :searchable="false" :class="{'invalid-border': errors.has('reminder_expired_day_in')}"></v-select>
              <span class="text-danger text-xs error-text-input span-text-validation hide-error mt-3" :class="{'show-error': errors.has('reminder_expired_day_in')}">The reminder after date field is required</span>
              <h4 class="text-lg font-bold">Message to show to customer</h4>
              <vs-textarea :maxlength="139" v-model="reminder_content" counter="139" :counter-danger.sync="counterDanger" height="150" />
              <h4 class="text-lg font-bold">Change Status</h4>
              <ul class="switch-container mb-base">
                <li>
                  <vs-switch v-model="reminder_is_active" @click.stop="switchActive"/>
                </li>
              </ul>
          </div>
      </div>
     </div>
   </VuePerfectScrollbar>
    <div class="flex justify-center flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.stop="updateReminder" style="min-width: 140px">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeUpdateRemin" style="min-width: 140px">Cancel</vs-button>
    </div>
  </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  name: "vs-update-reminder",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    flatPickr,
    'v-select': vSelect,
    VuePerfectScrollbar,
  },
  props: {
    updateReminConfig: {
      type: Object,
      required: true
    },
    sidebarData: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    }
  },
  data() {
      return {
          name: this.sidebarData.campaign.name,
          content: this.sidebarData.remind_campaign.content,
          is_active: this.sidebarData.campaign.is_active,
          logic_value: this.sidebarData.campaign.logic_value,
          logic_type: this.sidebarData.campaign.logic_type,
          after_date: this.sidebarData.remind_campaign.after_date,
          counterDanger: false,

          settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
          },

          offer_choices: [
            {text:'3 days',value:'3'},
            {text:'7 days',value:'7'},
            {text:'14 days',value:'14'},
            {text:'30 days',value:'30'}
          ],
          expired_day_in: {text: this.sidebarData.campaign.expired_day_in + ' days', value:this.sidebarData.campaign.expired_day_in},
          max: 100,
          abc: 0,
      }
  },
  computed: {
      id:{
        get() { return this.sidebarData.campaign.id;},
        set() {}
      },
      reminder_name: {
          get() { return  this.name; },
          set(value) {
            this.name = value;
          }
      },
      reminder_logic_value:{
        get() {return this.logic_value},
        set(value) {
          this.logic_value = value;
        }
      },
      reminder_logic_type:{
        get() {return this.logic_type},
        set(value) {
          this.logic_type = value
        }
      },
      reminder_content:{
        get(){
          return this.content;
        },
        set(value) {
          this.content = value;
        }
      },
      reminder_is_active:{
        get(){return this.is_active},
        set(value) {
          this.is_active = value;
        }
      },
      reminder_expired_day_in:{
        get(){return this.expired_day_in},
        set(value){
          {this.expired_day_in = value}
        }
      }
  },
   watch: {
    updateReminConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.name = this.sidebarData.campaign.name;
        this.content = this.sidebarData.remind_campaign.content;
        this.is_active = this.sidebarData.campaign.is_active;
        this.logic_value = this.sidebarData.campaign.logic_value;
        this.after_date = this.sidebarData.remind_campaign.after_date;
        // this.logic_type = this.sidebarData.campaign.logic_type;
        this.expired_day_in = {text: this.sidebarData.campaign.expired_day_in + ' days', value:this.sidebarData.campaign.expired_day_in},
        this.errors.clear();
        if(this.updateReminConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
          this.logic_type = this.sidebarData.campaign.logic_type;
          if(this.logic_type == 'usd'){
            this.max = 999;
          }else {
            this.max = 100;
          }
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    max: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.reminder_logic_value > val) {
          this.reminder_logic_value = val;
        }
      }
    }
  },
  methods: {
    switchActive(){
      this.is_active = this.is_active;
    },
    closeUpdateRemin() {
      this.$emit("CloseUpdateRemin");
    },
    updateReminder(){
      if(this.name != '' && this.expired_day_in != null){
         const obj = {
          id: this.id,
          name: this.name,
          content: this.content,
          is_active: this.is_active ? 1 : 0,
          logic_value: this.logic_value,
          logic_type: this.logic_type,
          expired_day_in: this.expired_day_in.value,
          after_date: this.after_date,
          page: this.currentPage,
         'per-page': this.itemsPerPage
        };
        this.$emit("UpdateReminder" ,obj);
        this.closeUpdateRemin();
      }
      this.$validator.validateAll();
    }
  }
};
</script>
